module.exports = __webpack_public_path__ + "static/media/Phones.c8d0ad33.png";